import Dropzone from "dropzone"
import { Controller } from "@hotwired/stimulus"
import { application } from "@controllers/application"

class DropzoneController extends Controller {
  connect() {
    new Dropzone(".dropzone", {
      paramName: "file",
      dictDefaultMessage: window.i18n.t("dropzone_message"),
    })
  }
}

application.register("common--dropzone", DropzoneController)
